import { createFileRoute } from "@tanstack/react-router"

import { WorkspacePage } from "~/components/design-system/pages"
import { ViewsSection } from "~/components/ingestion-cockpit/ViewsSection"

export const Route = createFileRoute("/_auth/ingestion-cockpit/_layout/views")({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <WorkspacePage>
      <ViewsSection />
    </WorkspacePage>
  )
}
